import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import FooterButtonsRow from '../shared/FooterButtonsRow/FooterButtonsRow';

const ResumePurchaseModal = ({ isOpen, cancelAction, toggle }) => {
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            centered
            className='md'
            aria-modal='true'
            role='dialog'
            aria-labelledBy='resume'
        >
            <ModalHeader className='noLine'></ModalHeader>
            <ModalBody className='text-center'>
                <h1
                    className='h4 mb-2'
                    id='resume'
                >
                    Are you sure you want to leave your purchase?
                </h1>
                <p>Any information entered will be lost.</p>
            </ModalBody>
            <ModalFooter>
                <FooterButtonsRow
                    isModal={true}
                    buttons={{
                        primary: {
                            text: 'Resume Purchase',
                            type: 'primary',
                            onClick: toggle,
                            ariaLabel: 'On click resumes the purchase.'
                        },
                        secondary: {
                            text: 'Cancel Purchase',
                            type: 'secondary',
                            onClick: cancelAction,
                            ariaLabel: 'On click cancels the purchase.'
                        }
                    }}
                />
            </ModalFooter>
        </Modal>
    );
};

export default ResumePurchaseModal;
